export const STOCK_ASSETS_HELP = 'https://help.shootsta.com/en/articles/5074650-how-to-purchase-stock-assets';

export const STOCK_FILTERS = {
  status: [
  { label: 'Popular', value: 'popular' },
  { label: 'Newest', value: 'newest' },
  { label: 'Relevance', value: 'relevance' },
  { label: 'Random', value: 'random' }]

};

export const ADVANCED_STOCK_FILTERS = [
// {
//   type: 'RADIO',
//   name: 'FAVOURITES',
//   label: 'Favourites',
//   openedByDefault: true,
//   filterFacets: [
//     { label: 'All', value: 'ALL', selectedDefault: true },
//     { label: 'Favourite', value: 'FAVOURITE' },
//     { label: 'Non-Favourite', value: 'NON_FAVOURITE' }
//   ]
// },
{ type: 'RADIO',
  name: 'CATEGORY',
  label: 'Category',
  placeholder: 'Select category',
  filterFacets: [
  // These categories are taken directly from Shutterstock API
  { label: 'Animals/Wildlife', value: 'Animals/Wildlife' },
  // { label: 'The Arts', value: 'The Arts' },
  { label: 'Backgrounds/Textures', value: 'Backgrounds/Textures' },
  { label: 'Buildings/Landmarks', value: 'Buildings/Landmarks' },
  { label: 'Business/Finance', value: 'Business/Finance' },
  { label: 'Education', value: 'Education' },
  { label: 'Food and Drink', value: 'Food and Drink' },
  // { label: 'Healthcare/Medical', value: 'Healthcare/Medical' },
  { label: 'Holidays', value: 'Holidays' },
  { label: 'Industrial', value: 'Industrial' },
  { label: 'Nature', value: 'Nature' },
  { label: 'Objects', value: 'Objects' },
  { label: 'People', value: 'People' },
  { label: 'Religion', value: 'Religion' },
  { label: 'Science', value: 'Science' },
  { label: 'Signs/Symbols', value: 'Signs/Symbols' },
  { label: 'Sports/Recreation', value: 'Sports/Recreation' },
  { label: 'Technology', value: 'Technology' },
  { label: 'Transportation', value: 'Transportation' }]

}
// {
//   type: 'RADIO',
//   name: 'PEOPLE',
//   label: 'People',
//   filterFacets: [
//     { label: 'All', value: 'ALL', selectedDefault: true },
//     { label: 'With people', value: 'WITH_PEOPLE' },
//     { label: 'Without people', value: 'WITHOUT_PEOPLE' }
//   ]
// }
];